import React from 'react';
import styles from './CheckBoxCostum.module.scss';

export class CheckboxCostumAuth extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            checked: this.props.checked
        }
    }


    handleChange = (e) => {
        const newValue = !this.state.checked
        this.setState({
            checked: newValue
        })
        if(this.props.handleChange) this.props.handleChange(e.target.dataset.value)
    }

    render() {
        const {
            label,checked, hideLabel, disabled=false
        } = this.props;
        const icon = checked
            ? 'icon-checked'
            : disabled
                ? 'icon-disabled'
                : 'icon';
        return (
            <div className={styles['checkbox-container']}>
                <button type="button" className={styles["button"]} data-value={label} data-checked={checked} onClick={this.handleChange} data-automation-id="checkbox">
                    {!this.props.checked && <div  data-value={label} className={styles["unchecked"]}><i></i></div>}
                    {this.props.checked && <i  data-value={label} className={"icon-check-square " + styles[icon]}></i>}
                    {!hideLabel && <> <label className={styles["label"]}  data-value={label}> {label}</label><br></br></>}
                </button>
            </div>
        )
    }

}


CheckboxCostumAuth.propTypes = {};

export default CheckboxCostumAuth;